import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthService } from '../../auth.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<string>> {
    return next.handle(req).pipe(
      catchError(err => {
        const error = (err && err.error && err.error.message) || err.statusText;

        if (err.status === 401) {
          // A step-up challenge (e.g. disabling MFA on a stale session) is not a dead session.
          // Let the caller prompt re-authentication instead of signing the user out globally.
          if (err.error?.title === 'reauthentication_required') {
            return throwError(() => err);
          }

          return from(
            this.authService.signOut(true, this.authService.getSessionExpiredSignOutOptions())
          ).pipe(switchMap(() => throwError(() => error)));
        }

        return throwError(() => error);
      })
    );
  }
}
